import reportWebVitals from './reportWebVitals';
import {
    RootApp
} from './_apps/rootApp';
import './index.css';
import { ConfigProvider } from 'antd';
import React, { FC, ReactElement } from 'react';
import ReactDOM from 'react-dom/client';
import './appParts';

let isMountedManually = false;

window.mountExternalApp = (containerId = 'root') => {
    const element = document.getElementById(containerId);
    if (!element) return;
    if (window.externalAppRoot) {
        window.externalAppRoot.unmount();
    }
    window.externalAppRoot = ReactDOM.createRoot(element);
    window.externalAppRoot.render(
        <React.StrictMode>
            <ConfigProvider theme={{
                components: {
                    Button: {
                        borderRadius: 2,
                        borderRadiusLG: 2,
                        defaultBorderColor: '#3d5769',
                        defaultHoverBorderColor: '#0f243c',
                        colorPrimary: '#0f243c',
                        colorPrimaryHover: '#3d5769',
                        defaultHoverColor: '#3d5769',
                        defaultActiveColor: '#3d5769',
                        colorPrimaryActive: '#3d5769',
                    },
                },
            }}>
                <RootApp />
            </ConfigProvider>
        </React.StrictMode>
    );
    isMountedManually = true;
};

window.unmountExternalApp = () => {
    if (window.externalAppRoot) {
        window.externalAppRoot.unmount();
        window.externalAppRoot = null;
    }
    isMountedManually = false;
};

// Автоматическое монтирование, если не вызвано вручную
if (!isMountedManually) {
    window.mountExternalApp('root');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
